<template>
  <b-card class="chat-message">
    <span class="time">{{message.time_stamp | getMomentStr}}</span><br>
    <player-link :playerId="message.user_id" /> left the club.
  </b-card>
</template>

<script>
import PlayerLink from '../PlayerLink.vue';

export default {
  name: 'MessageMemberLeft',

  components: {
    PlayerLink,
  },

  props: {
    message: {
      type: Object,
      required: true,
    }
  },
};
</script>
